import moment from "@/services/momentjs";

export const DateHelpers = {
  filters: {
    dateFormat: function(date, format = "DD MMM YYYY") {
      return moment(date).format(format);
    }
  },

  methods: {
    humanizeDate: function(date, format = "LL") {
      return moment(date).format(format);
    },

    shortDate: function(date) {
      return moment(date).format("YYYY-MM-DD");
    },

    dateIsInThePast: function (date) {
      return moment(date).isBefore(moment())
    },

    dateFromNow: function (date) {
      return moment(date).fromNow()
    },

    dateDiffFromNow: function (to, format = 'days') {
      return moment(to).diff(moment(), format)
    },

    minutesDurationToHours: function (minutes) {
      if (minutes < 60) {
        return moment.utc(moment.duration(minutes, "minutes").asMilliseconds()).format("mm[ minutes]")
      } else {
        return moment.utc(moment.duration(minutes, "minutes").asMilliseconds()).format("H[h]mm")
      }
    }
  }
};
